<template>
    <div>
        <UiModalsSubscribeModal id="sbSubscribeModal" :blok="blok" :form-state="formState" @submit="submitForm" />
    </div>
</template>

<script lang="ts" setup>
import { useGlobalStore } from '@nuxt-monorepo/base/app/store/global';
import { useEmailSubscriptionStore } from '@nuxt-monorepo/base/app/store/emailSubscription';
import type {
    ISubscribeModal,
    ISubscribeModalFormState,
} from '@nuxt-monorepo/ui/types/components/modals/SubscribeModal';
import { useSearchStore } from '@nuxt-monorepo/base/app/store/search';
import { useTabbedSearchStore } from '@nuxt-monorepo/base/app/store/tabbedSearch';
const { blok } = defineProps<{ blok: ISubscribeModal }>();

const formState = ref<ISubscribeModalFormState>({
    success: false,
    isSubmitted: false,
    responseMsg: null,
});

const emailSubscriptionStore = useEmailSubscriptionStore();
const config = useRuntimeConfig();
const globalStore: any = useGlobalStore();

// Get access to the router instance
const router = useRouter();
// Get access to the current route
const route = useRoute();
// Constant variable for access to search store
const searchStore = useSearchStore();
// Constant variable for access to tabbed search store
const tabbedSearchStore = useTabbedSearchStore();

const updatePromoParam = () => {
    const currentQuery = route.query;

    const updatedQuery = {
        ...currentQuery,
        promo: blok.discountCode,
    };

    router.push({ query: updatedQuery as any });
    //set promo code into Searchbox
    searchStore.updatePromo(blok.discountCode);
    tabbedSearchStore.updateDiscount(blok.discountCode);
};
const submitForm = async (formData: any) => {
    const email = formData.email;
    formState.value.isSubmitted = true;
    const apiUrl = globalStore.global.UseMparticle ? '/api/subscribe-mparticle' : '/api/subscribe';
    return await $fetch(apiUrl, {
        method: 'POST',
        body: { email, listId: config?.public.ITERABLE_LIST_ID, signupSource: blok.signupSource ?? 'headerModal' },
        onResponse({ response }) {
            if (response.ok) {
                emailSubscriptionStore.updateIsSubscribed(true);
                formState.value.responseMsg = '';
                formState.value.success = true;
                formState.value.isSubmitted = false;
                updatePromoParam();
            }
        },
        onResponseError({ response }) {
            if (response) {
                formState.value.isSubmitted = true;
                formState.value.success = false;
                formState.value.responseMsg = blok.defaultErrorMessage;
                console.error(response);
            }
        },
    });
};
</script>

<style lang="postcss" scoped>
:deep(.subscribe-modal) {
    .input-group {
        input {
            @apply text-base;
        }
        .error-message {
            @apply text-sm;
        }
    }
}
</style>
